export default "__VITE_ASSET__5OsyDOhd__"